import { render, staticRenderFns } from "./B2BReport.vue?vue&type=template&id=0eb68c9e"
import script from "./B2BReport.vue?vue&type=script&lang=js"
export * from "./B2BReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports